let coreInternalAdminApiRouteBase =   environment.base.apiUrl + '/api';
let coreRestatementApiRouteBase = environment.base.apiUrl.indexOf('localhost') > 0 ? coreInternalAdminApiRouteBase : environment.base.apiUrl + '/api';
let aaRestatementRoute = coreInternalAdminApiRouteBase + '/RetirementDocuments/';
let safeHarborRoute= coreRestatementApiRouteBase + '/RetirementDocuments';
 
export const apiRouteConstants = {

  aaRestatement: {
    primaryUrl: aaRestatementRoute,
    retirementDocuments: aaRestatementRoute + '/RetirementDocuments',
    restatementsSelect: coreRestatementApiRouteBase + '/RetirementDocuments/GetAdoptionAgreementsLux2?personId=',
    restatementsPost: coreRestatementApiRouteBase + '/RetirementDocuments/SubmitAdoptionAgreementsLux2',
    nonRestatementsPost: coreRestatementApiRouteBase + '/RetirementDocuments/SubmitAdoptionAgreementsNonRestatementsLux2'
    },

    safeHarbor: {
      primaryUrl: safeHarborRoute,
      safeHarborPlans: safeHarborRoute + '/GetSafeHarborPlans',
      // submitSafeHarborPlans: safeHarborRoute + '/submitsafeharborplans'
      submitSafeHarborPlans: safeHarborRoute + '/safeharbor'
    },

  retirementPlanDocuments: {
    primaryUrl: aaRestatementRoute,
    GetLux2: coreRestatementApiRouteBase + '/RetirementDocuments/GetLux2?personId=',
    SubmitSpdSmmAcknowledgementLux2: coreRestatementApiRouteBase + '/RetirementDocuments/SubmitSpdSmmAcknowledgementLux2',
    SubmitSafeHarborAcknowledgementLux2: coreRestatementApiRouteBase + '/RetirementDocuments/SubmitSafeHarborAcknowledgementLux2',
    GetAcknowledgementsForPrintLux2: coreRestatementApiRouteBase + '/RetirementDocuments/GetAcknowledgementsForPrintLux2' //this is a POST because it takes an object
  },

  messageCenterGetMessageCountsUnread:{
    primaryUrl: environment.base.apiUrl  + '/api/messageCenter/messages/count/unread'
  },

  messageCenterGetFolderMessagesUrl(folder,userId){
    return `${environment.base.apiUrl}/api/messageCenter/messages/${folder}/`;
  }
};
